<template>
  <DependencyTable
    entity-type="deliveryrun"
    :columns="deliveryRunColumns"
    :meta-data="{ currentPage: 1, resultsPerPage: deliveryRunCount }"
    :items="deliveryRuns"
    :title="$t('deliveryprocessdefinition.dependencies.deliveryRuns.title', { count: deliveryRunCount })"
    :no-results-text="$t('deliveryprocessdefinition.dependencies.deliveryRuns.noResults')"
  />
</template>
<script lang="ts" setup>
import { DeliveryRunBasicDto } from '@/api/backoffice/clients';
import { PropType, computed } from 'vue';
import DependencyTable from '@/modules/configuration/views/shared/DependencyTable.vue';
import { format } from 'date-fns';

defineProps({
  deliveryRuns: {
    type: Object as PropType<DeliveryRunBasicDto[]>,
    required: true
  }
});

const deliveryRunCount = 10;

const deliveryRunColumns = computed(() => {
  return [
    {
      accessorKey: 'id',
      header: 'Id',
      enableSorting: true,
      size: 5,
      link: true
    },
    {
      accessorKey: 'status.executionDate',
      header: 'Datum',
      enableSorting: true,
      sortDescFirst: false,
      size: 30,
      link: true,
      cell: (props) => {
        const status = props.row.original.status;
        if (!status || !status.executionDate) {
          return '-';
        }

        try {
          const executionDate = format(status.executionDate, 'dd.MM.yyyy');
          return executionDate;
        } catch (e) {
          console.log('foutieve datum', status);
          return '-';
        }
      }
    },
    {
      accessorKey: 'status.description',
      header: 'Status',
      enableSorting: true,
      sortDescFirst: false,
      size: 30,
      link: true
    },
    {
      accessorKey: 'isDryRun',
      header: 'Is Dry Run',
      enableSorting: true,
      sortDescFirst: false,
      size: 30,
      link: true,
      cell: (props) => {
        const val = props.row.original;
        return val.isDryRun ? 'Ja' : 'Neen';
      }
    }
  ];
});
</script>
<style lang="scss" scoped></style>
